module.exports = __webpack_public_path__ + "static/media/corporate.8d8365e8.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/corporate.PNG
// module id = 1395
// module chunks = 1